<template>
  <div class="columns">
    <div class="column is-flex">
      <div class="boxWithBorder">
        <div class="">
        <h3 class="subtitle has-text-weight-bold">Need support with your TripCircuit online booking?</h3>
        
        <h4 class="has-text-weight-bold">Email Gant's Online Team</h4>
        <p>
          <a href="mailto:clientservices@ganttravel.com">
            clientservices@ganttravel.com
          </a>
        </p>

        <h4 class="mt-4 has-text-weight-bold">Chat with Us</h4>
          
        <p>
          Use the chat button in the lower right corner of your screen or click the button below to begin.
        </p>

        <b-button type="is-primary" class="mt-3" @click.prevent="$emit('openChat')">Start chat</b-button>

      </div>
      </div>
    </div>
    <div class="column is-flex">
      <div class="boxWithBorder">
        <div class="">
          <h3 class="subtitle has-text-weight-bold">Booking Same-Day Travel or need After-Hours assistance? </h3>
          <p>Contact Gant Travel directly for agent assistance at  877-924-0303</p>
        </div>
      </div>
    </div>
    <div class="column is-one-third">
      <div class="boxWithBorder">
        <div class="">
          <h3 class="subtitle has-text-weight-bold">Traveling Internationally?</h3>
          <p>
            <a href="https://cibtvisas.com/gant-travel?login=ganttravel" target="_blank">
              View International Visa Requirements
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: 'HomeWelcomeMessage'
    }

</script>

<style scoped>
</style>
